import { palette, animations } from '../../theme';

export const mobileYearPickerStyles = {
  wrapper: {
    width: '100%',
    height: '500px',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    overflowY: 'auto' as const,
    paddingBottom: '40px',
    ...animations.appearanceEffect,
  },

  yearButton: {
    minWidth: '120px',
    height: '50px',
    margin: '8px',
    fontSize: '18px',
    fontWeight: 'normal',
    borderRadius: '25px',
    textTransform: 'none' as const,
    border: 'none',
    backgroundColor: 'transparent',
    color: palette.text.primary,
    '&:hover': {
      backgroundColor: palette.grey[100],
    },
  },

  selectedYearButton: {
    minWidth: '120px',
    height: '50px',
    margin: '8px',
    fontSize: '18px',
    borderRadius: '25px',
    textTransform: 'none' as const,
    border: 'none',
    backgroundColor: palette.primary.main,
    color: palette.background.paper,
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: palette.primary.main,
    },
  },
};
